import { Button, HStack, Spinner, Text } from "@chakra-ui/react";
import { FaRobot, FaStopCircle } from "react-icons/fa";

export default function AnalyzeBtn({
  analysisAvailability,
  analysisReadiness,
  handleCancelAnalysis,
  handleRunReport,
  isLoading = false,
  isAnalyzing = false,
  selectedReport,
  usageLimitReached = false,
  t,
}) {
  const isBusy = isLoading || isAnalyzing;
  const isDisabled =
    !isAnalyzing &&
    (usageLimitReached ||
      !selectedReport ||
      isLoading ||
      analysisAvailability?.isAvailable === false ||
      analysisReadiness?.isReady === false);

  return (
    <Button
      leftIcon={isAnalyzing ? <FaStopCircle /> : <FaRobot />}
      colorScheme={isAnalyzing ? "red" : "green"}
      size="md"
      isDisabled={isDisabled}
      onClick={isAnalyzing ? handleCancelAnalysis : handleRunReport}
      minW="200px"
    >
      {isAnalyzing ? (
        t("reports.cancelAnalysis", "إيقاف التحليل")
      ) : isBusy ? (
        <HStack spacing={2}>
          <Spinner size="sm" />
          <Text>{t("reports.processing", "جاري المعالجة...")}</Text>
        </HStack>
      ) : (
        t("reports.smartAnalysisWithAI", "تحليل ذكي مع AI")
      )}
    </Button>
  );
}
